import { VariantProps } from "@stitches/react";
import { ComponentProps } from "react";
import { styled } from "~/application/theme";

export type SwitchButtonProps = ComponentProps<typeof SwitchButton>;

export type SwitchButtonVariants = VariantProps<typeof SwitchButton>;

export const SwitchButton = styled("span", {
  // Reset
  display: "block",
  boxSizing: "border-box",

  // Custom Reset?
  inset: 0,

  // Custom
  position: "relative",
  backgroundColor: "$neutrals-base",
  border: "none",
  overflow: "hidden",
  borderRadius: "24px",
  width: "48px",
  height: "24px",
  transition: "$slow",

  "&:hover": {
    cursor: "pointer",
    "&::before": {
      boxShadow: "0px 0px 0px 8px rgba(0, 100, 197, 0.08)",
    },
  },

  "&::before": {
    content: "",
    display: "block",
    position: "absolute",
    height: "20px",
    width: "20px",
    borderRadius: "$circular",
    backgroundColor: "$neutrals-white",
    left: 2,
    top: 2,
    transition: "$slow",
    boxShadow: "0 2px 4px rgba(0, 0, 0, 0.2)",
  },

  "&:focus": {
    boxShadow: "$focus-sm",
  },

  "&[data-checked=true]": {
    backgroundColor: "$primary-base",

    "&::before": {
      backgroundColor: "$neutrals-white",
      left: "calc(100% - 22px)",
    },
  },

  "&[data-disabled=true]": {
    pointerEvents: "none",
    backgroundColor: "$neutrals-light",
    opacity: 0.5,

    "&::before": {
      backgroundColor: "$neutrals-white",
    },
  },
});

SwitchButton.displayName = "SwitchButton";
